import type { MergedWorkspace, SampleAccount, WorkspaceObjectType } from '.';
import { deprecatedApi, servicesApi } from '@/services/api/deprecated';

export const listWorkspaces = async (accountId: number) => {
  const { data } = await deprecatedApi.get<MergedWorkspace[]>(`/accounts/${accountId}/workspaces`);
  return data;
};

export const sampleAccounts = async () => {
  const { data } = await servicesApi.get<SampleAccount[]>(`/sample_accounts`);
  return data;
};

export const listWorkspaceObjectTypes = async (accountId: number, workspaceId: number) => {
  const { data } = await servicesApi.get<{ object_types: WorkspaceObjectType[] }>(
    `/environments/${workspaceId}/object_types`,
  );
  return data.object_types;
};
